import { render, staticRenderFns } from "./Last.vue?vue&type=template&id=762bab87&scoped=true&"
import script from "./Last.vue?vue&type=script&lang=js&"
export * from "./Last.vue?vue&type=script&lang=js&"
import style0 from "./Last.vue?vue&type=style&index=0&id=762bab87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762bab87",
  null
  
)

export default component.exports